import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
// Import assets
import Logo from "../../assets/logo.svg";

const NavLink = ({
  to,
  children,
  className = "",
  variant = "link",
  onClick,
}) => {
  const baseStyles = {
    link: "text-dark-blue-text hover:text-primary transition",
    buttonPrimary:
      "flex items-center justify-center text-purple-text rounded-md bg-background w-full h-full",
    buttonSecondary:
      "flex items-center justify-center text-white-text rounded-md bg-gradient-purple shadow-custom-blue",
  };

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`${baseStyles[variant] || ""} ${className}`.trim()}
    >
      {children}
    </Link>
  );
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  //Lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      <div className="w-full flex justify-center z-50">
        <div className="flex justify-between items-center max-w-[1250px] w-10/12 h-[60px] ">
          {/* Logo */}
          <div className="border border-red-600">
            <Link to="/" className="flex items-center justify-center">
              {/* <img
                src={Logo}
                alt="Roselea Logo"
                className="w-[100px] h-[50px] sm:w-[158px] sm:h-[50px] lg:w-[168px] lg:h-[60px] border border-red-600"
              /> */}
            </Link>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex md:items-center md:justify-around md:space-x-8 lg:space-x-12 xl:space-x-18 font-inter font-semibold w-2/3">
            <div className="w-1/2 flex justify-between pl-5 lg:pl-10">
              <NavLink to="/" className="font-semibold text-level-6 xl:text-lg">
                Home
              </NavLink>
              <NavLink
                to="/about"
                className="font-semibold text-level-6 xl:text-lg"
              >
                About Us
              </NavLink>
              <NavLink
                to="/contact"
                className="font-semibold text-level-6 xl:text-lg"
              >
                Contact Us
              </NavLink>
            </div>
            <div className="flex items-center justify-around w-1/3 lg:w-1/3">
              <div className="bg-gradient-purple md:h-[35px] md:w-[70px] xl:h-[46px] xl:w-[115px] relative rounded-[8px] p-0.5">
                <NavLink
                  to="/signup"
                  variant="buttonPrimary"
                  className="font-alexandria font-semibold text-level-7 xl:text-level-5 text-center "
                >
                  Sign Up
                </NavLink>
              </div>
              <NavLink
                to="/signin"
                variant="buttonSecondary"
                className="font-alexandria font-semibold text-level-7 xl:text-level-5 text-center h-[40px] md:h-[35px] xl:h-[46px] w-[65px] xl:w-[115px]"
              >
                Login
              </NavLink>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            >
              {isOpen ? (
                <X className="w-6 h-6 text-dark" />
              ) : (
                <Menu className="w-6 h-6 text-dark" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`
                      fixed inset-0 z-40 top-[80px]
                      flex flex-col justify-between
                      bg-background
                      px-4 py-6
                      md:hidden
                      font-inter font-semibold
                      transition-all duration-300 ease-in-out overflow-y-hidden 
                      ${isOpen ? "opacity-100 visible " : "opacity-0 invisible"}
                    `}
      >
        {/* Top Group */}
        <div className="space-y-4 mt-4">
          <NavLink
            to="/"
            className="block px-3 py-2 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className="block px-3 py-2 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            About Us
          </NavLink>
          <NavLink
            to="/contact"
            className="block px-3 py-2 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            Contact Us
          </NavLink>
        </div>

        {/* Bottom Group */}
        <div className="space-y-3 font-alexandria">
          <div className="bg-gradient-purple relative w-full h-12 rounded-[8px] p-0.5">
            <NavLink
              to="/signup"
              variant="buttonPrimary"
              onClick={() => setIsOpen(false)}
            >
              Sign Up
            </NavLink>
          </div>
          <NavLink
            to="/login"
            variant="buttonSecondary"
            className="w-full h-12"
            onClick={() => setIsOpen(false)}
          >
            Login
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Navbar;
